import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [{
    path: '/',
    redirect: '/logins'
  },
  {
    path: '/successful',
    name: 'Successful',
    component: resolve => require(['@/components/newCrownDetection/successful'], resolve),
    meta: { title: '成功' }
  },
  {
    path: '/logins',
    name: 'logins',
    component: resolve => require(['@/components/newCrownDetection/logins'], resolve),
    meta: { title: '登录' }
  },
  {
    path: '/newCrownDetection',
    name: 'newCrownDetection',
    component: resolve => require(['@/components/newCrownDetection/newCrownDetection'], resolve),
    meta: { title: '核酸检测' }
  }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js